module.exports = __webpack_public_path__ + "static/media/gab.337f88ad.svg";